import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import OfferService from "../../services/OffersService";
import OfferRedeemService from "../../services/OfferRedeemService";

export const checkOfferRedeemCode = createAsyncThunk(
  "offer-redeem/checkOfferRedeemCode",
  async (data) => {
    try {
      const res = await OfferRedeemService.offerRedeemCodeCheck(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const offerRedeemCode = createAsyncThunk(
  "offer-redeem/offerRedeemCode",
  async (data, { rejectWithValue }) => {
    try {
      const res = await OfferRedeemService.useOfferRedeem(data);
      return res.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error?.response?.message);
    }
  }
);

export const fetchOffersRedeemLogs = createAsyncThunk(
  "offer-redeem/fetchOffersRedeemLogs",
  async (data, { rejectWithValue }) => {
    try {
      const res = await OfferRedeemService.getOffersRedeemLogs(data);
      return res.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error?.response?.message);
    }
  }
);

const initialState = {
  loading: false,
  error: "",
  offerRedeem: null,
  offerRedeemCustomerData: null,
  offersRedeemList: [],
  total_records: 0,
  total_records: 0,
};

const offerRedeemSlice = createSlice({
  name: "offer-redeem",
  initialState,
  reducers: {},
  extraReducers(builder) {
    // Create Offer Redeem Code

    builder
      .addCase(checkOfferRedeemCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkOfferRedeemCode.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.offerRedeemCustomerData = payload?.data || null;
      })
      .addCase(checkOfferRedeemCode.rejected, (state) => {
        state.loading = false;
      });

    // Offer Redeem Code

    builder
      .addCase(offerRedeemCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(offerRedeemCode.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.offerRedeemCustomerData = payload?.data || null;
      })
      .addCase(offerRedeemCode.rejected, (state) => {
        state.loading = false;
      });

    // Offers Redeem Logs

    builder
      .addCase(fetchOffersRedeemLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOffersRedeemLogs.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.offersRedeemList = payload?.data || [];
        state.total_pages = payload?.total_pages;
        state.total_records = payload?.total_records;
      })
      .addCase(fetchOffersRedeemLogs.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default offerRedeemSlice.reducer;
